module.exports = "<p>\r\n  service provider\r\n</p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized-data/post-services-listing/service-provider-list/service-provider-list.component.html
// module id = ./src/app/authorized-data/post-services-listing/service-provider-list/service-provider-list.component.html
// module chunks = main